import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedDuration from 'I18n/components/FormattedDuration';
import { jsx as _jsx } from "react/jsx-runtime";
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;
export function RelativeTime({
  timestamp
}) {
  // eslint-disable-next-line react-hooks/purity
  const diffMs = Date.now() - timestamp;
  if (diffMs < ONE_WEEK_MS) {
    return /*#__PURE__*/_jsx(FormattedDuration, {
      to: timestamp,
      includeAffix: true
    });
  }
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    value: timestamp,
    format: "ll",
    type: "userTz"
  });
}